import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { app } from "../firebase/connectFirebase";

const getModelsURL = (modelName: string) => {
  if (!modelName) return;
  const storage = getStorage(app);
  return getDownloadURL(ref(storage, modelName)).catch(console.error);
};

export default getModelsURL;
